<template>
  <div class="ivu-shrinkable-menu" id="leftPanel">
    <div class="menuContainer">
      <sidebar-menu
        :accordion="accordion"
        :activeName="activeName"
        :menus="currenMenus"
        @on-change="handleChange"
        v-if="!shrink"
      ></sidebar-menu>
      <sidebar-menu-shrink
        :activeName="activeName"
        :menus="currenMenus"
        @on-change="handleChange"
        v-else
      ></sidebar-menu-shrink>
    </div>
    <slot name="buttom"></slot>
  </div>
</template>

<script>
import sidebarMenu from './shrinkable-menu/sidebarMenu.vue'
import sidebarMenuShrink from './shrinkable-menu/sidebarMenuShrink.vue'
export default {
  name: 'shrinkableMenu',
  components: {
    sidebarMenu,
    sidebarMenuShrink
  },
  props: {
    accordion: {
      type: Boolean,
      default: false
    },
    shrink: {
      type: Boolean,
      default: false
    },
    menus: {
      type: Object,
      default: {}
    },
    activeName: {
      type: String
    }
  },
  data () {
    return {
      currenMenus: {}
    }
  },
  watch: {
    menus: {
      handler (newValue, oldValue) {
        console.log("menus change", newValue)
        this.currenMenus = newValue
      },
      deep: true
    }
  },

  methods: {
    handleChange (name) {
      console.log("name", name)
      this.$store.dispatch("menuInfo/updateMenuInfoParams", { key: 'activeName', value: name })
      this.$router.push({ name: name })
    }
  },
  beforeMount () {
    this.currenMenus = this.menus
  },
  mounted () {
    console.log("rece menus", this.currenMenus)
  }
};
</script>
<style>
.ivu-shrinkable-menu {
  height: 100%;
  width: auto;
}
.vb {
  height: 100% !important;
}
</style>
